import { htmlParaExibicao } from "./htmlMensagem";
import "./mensagemGlobal.css";

export const ConteudoFormatado = ({ conteudo, className = "" }) => {
  return (
    <div
      className={`conteudo-mensagem ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: htmlParaExibicao(conteudo) }}
    />
  );
};
